module.exports = __webpack_public_path__ + "static/media/si-transistor.ffec8bed.png";